import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/client';
export function useEventSearch(search, city, startDate, endDate, limit = 50) {
    return useQuery({
        queryKey: ['search:events', search, city, startDate, endDate, limit],
        queryFn: async () => {
            const response = await apiClient.get('/api/v1/search/events', {
                params: { search, city, startDate, endDate, limit }
            });
            // We now extract the paginated 'data' array
            return response.data.data;
        },
        staleTime: 60000,
    });
}
